import React from 'react';
import { Link } from 'react-router-dom';
import { getCategoryDisplayName } from '../../../services/blogService';

export default function ArticleCard({ article }) {
  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      {/* Category Badge */}
      <div className="p-4 pb-0">
        <span className="inline-block px-3 py-1 text-xs font-semibold text-blue-600 bg-blue-100 rounded-full">
          {getCategoryDisplayName(article?.category)}
        </span>
      </div>
      {/* Article Content */}
      <div className="p-6 pt-4">
        <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">
          <Link 
            to={`/blog/${article?.slug}`}
            className="hover:text-blue-600 transition-colors"
          >
            {article?.title}
          </Link>
        </h3>

        <p className="text-gray-600 mb-4 line-clamp-3">
          {article?.excerpt}
        </p>

        {/* Article Meta */}
        <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
          <div className="flex items-center space-x-4">
            <span className="flex items-center">
              <svg 
                className="w-4 h-4 mr-1" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
                aria-hidden="true"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" 
                />
              </svg>
              <time dateTime={article?.publishedDate}>
                {formatDate(article?.publishedDate)}
              </time>
            </span>

            <span className="flex items-center">
              <svg 
                className="w-4 h-4 mr-1" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
                aria-hidden="true"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              {article?.readingTimeMinutes} min read
            </span>
          </div>
        </div>

        {/* Read More Link */}
        <Link 
          to={`/blog/${article?.slug}`}
          className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors"
        >
          Read full article
          <svg 
            className="ml-2 w-4 h-4" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
            aria-hidden="true"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9 5l7 7-7 7" 
            />
          </svg>
        </Link>
      </div>
    </article>
  );
}